import React from 'react';
import { MoreVertical } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

/**
 * KebabMenu — mobile-only ⋮ dropdown for secondary actions (Export, etc.)
 *
 * Usage:
 * <KebabMenu items={[
 *   { label: 'Export', icon: Download, onClick: handleExport },
 *   { label: 'Import', icon: Upload, onClick: handleImport },
 * ]} />
 */
export const KebabMenu = ({
  items = [],
  className,
  'data-testid': dataTestId = 'kebab-menu',
}) => {
  if (!items.length) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className={`h-10 w-10 shrink-0 ${className || ''}`}
          data-testid={dataTestId}
          aria-label="More actions"
        >
          <MoreVertical className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        {items.map((item, i) => (
          <DropdownMenuItem
            key={i}
            onClick={item.onClick}
            className={`cursor-pointer ${item.variant === 'destructive' ? 'text-destructive focus:text-destructive' : ''}`}
            data-testid={item['data-testid']}
          >
            {item.icon && <item.icon className="w-4 h-4 mr-2" />}
            {item.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default KebabMenu;
